import { useState } from 'react';
import { Button } from '@repo/ui/src/components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@repo/ui/src/components/ui/alert-dialog';
import { useSetOrgSuspended } from '../../hooks/useAdminOrgs';

interface SuspendOrgButtonProps {
  orgId: string;
  suspended: boolean;
}

export function SuspendOrgButton({ orgId, suspended }: SuspendOrgButtonProps) {
  const [open, setOpen] = useState(false);
  const setSuspended = useSetOrgSuspended(orgId);

  if (suspended) {
    return (
      <Button
        type="button"
        variant="outline"
        disabled={setSuspended.isPending}
        onClick={() => setSuspended.mutate(false)}
      >
        Mở khoá tổ chức
      </Button>
    );
  }

  return (
    <>
      <Button type="button" variant="destructive" onClick={() => setOpen(true)}>
        Khoá tổ chức
      </Button>

      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Khoá tổ chức</AlertDialogTitle>
            <AlertDialogDescription>
              Người dùng của tổ chức này sẽ không đăng nhập được nữa. Phiên đang mở sẽ dừng trong
              vòng 15 phút.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={setSuspended.isPending}>Huỷ</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                setSuspended.mutate(true, { onSuccess: () => setOpen(false) });
              }}
              disabled={setSuspended.isPending}
              className="bg-red-600 hover:bg-red-700"
            >
              Khoá tổ chức
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
